import {FC, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

/** The places the bottom bar leads to: no way back is needed from them. */
const TOP_LEVEL = [
  '/dashboard',
  '/apps/invoice-management/invoices',
  '/reports',
  '/OneRowQueueInvoice',
]

const runsAsInstalledApp = () =>
  typeof window !== 'undefined' &&
  (Boolean(window.matchMedia?.('(display-mode: standalone)').matches) ||
    (window.navigator as Navigator & {standalone?: boolean}).standalone === true)

/**
 * «بازگشت» in the header of the installed app (508): an installed iPhone app has no browser back button, so a page
 * opened from a list had no way back but the menu. In a browser tab the browser's own button does it.
 */
const StandaloneBackButton: FC = () => {
  const {pathname, key} = useLocation()
  const navigate = useNavigate()
  const [installed] = useState(runsAsInstalledApp)

  if (!installed || TOP_LEVEL.includes(pathname.replace(/\/+$/, ''))) return null

  return (
    <button
      type='button'
      className='btn btn-icon btn-active-color-primary w-40px h-40px mp-header-back'
      aria-label='بازگشت'
      // The app's first page (opened from the home screen or a link) has no page of the app behind it.
      onClick={() => (key === 'default' ? navigate('/dashboard') : navigate(-1))}
    >
      <i className='las la-arrow-right fs-1' aria-hidden='true'></i>
    </button>
  )
}

export {StandaloneBackButton}
